import { Module } from '../../../node_modules/vuex';
import { RootState } from '../types';
import { AuthState } from './types';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: AuthState = {
    accessToken: null,
    loggedIn: false,
    email: null,
    authorities: [],
    activeCompany: null,
    companies: [],
    group: null,
    isB2B: false,
};

const namespaced = true;

export const auth: Module<AuthState, RootState> = {
    namespaced,
    state,
    mutations,
    getters,
    actions
};
